import React from 'react';
import { motion } from 'framer-motion';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-cream/90 backdrop-blur-md shadow-sm border-b border-mint/10" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-73">
        <div className="flex items-center gap-2" data-id="element-74">
          <div className="w-8 h-8 rounded-full bg-mint flex items-center justify-center text-white font-serif font-bold text-xl" data-id="element-75">
            T
          </div>
          <span className="font-serif font-bold text-2xl text-dark" data-id="element-76">
            Tricotín <span className="text-mint" data-id="element-77">Rentable</span>
          </span>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="hidden sm:flex items-center gap-2 bg-pink-soft/30 px-4 py-2 rounded-full border border-pink-soft" data-id="element-78">
          <span className="relative flex h-3 w-3" data-id="element-79">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose opacity-75" data-id="element-80"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-rose" data-id="element-81"></span>
          </span>
          <span className="text-sm font-medium text-dark" data-id="element-82">
            Oferta por Tiempo Limitado
          </span>
        </motion.div>
      </div>
    </header>;
}